<template>
  <v-row>
    <v-col class="col-12 mt-3" v-if="estimateData">
      <EstimatePreviewList
          v-for="(child, index) in estimateData"
          v-model="estimateData[index]"
          :key="estimateData[index].id"
          :level="0"
          :showVat="showVat"
      >
      </EstimatePreviewList>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import EstimatePreviewList from "./EstimatePreviewList.vue";

export default {
  name: "EstimatePreview",
  props: {
    estimateData: Array,
    vatSettlement: [Object, Number],
    isOfferForm: Boolean,
  },
  components: {
    EstimatePreviewList
  },
  methods: {
    ...mapActions("getVat", ["getVat"]),
  },
  computed: {
    ...mapState("getVat", {
      vatData: state => state.vat
    }),
    ...mapState("getProject", {
      project: state => state.dataReceive
    }),
    showVat() {
        if(!this.vatSettlement && !this.isOfferForm) {
          if (this.project.showVat) {
            return this.project.showVat;
          } else {
            return localStorage.getItem("companyIsVatPayer") === 'false' ? false : true;
          }     
        } else if (this.isOfferForm) {
          return localStorage.getItem("companyIsVatPayer") === 'false' ? false : true;
        } else {
          return typeof(this.vatSettlement) === 'object' ? this.vatSettlement.name === 'FA_VAT' : this.vatSettlement === 2;
        }
    }
  }
}
</script>
